<template>
  <div class="pagePaypasswordEdit">
    <XR-head titleText="支付密码修改" :rightShow="false" ref="headObj"></XR-head>
    <div>      
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
          <mu-text-field label="旧密码" type="password" helpText="请输入您的旧密码" labelFloat fullWidth v-model="editInfo.payPassword" />
        </mu-col>
      </mu-row>      
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
          <mu-text-field label="新密码" type="password" helpText="请输入您的新密码" labelFloat fullWidth v-model="editInfo.newPayPassword" />
        </mu-col>
      </mu-row>      
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
          <mu-text-field label="确认密码" type="password" helpText="请再次输入您的新密码" labelFloat fullWidth v-model="editInfo.confrimNewPayPassword" />
        </mu-col>
      </mu-row>    
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="33" class="btn-div">          
          <mu-raised-button label="确 定" class="submit" primary fullWidth @click="submit()" />
        </mu-col>
      </mu-row>  
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
          <!-- <mu-flat-button label="忘记密码" to="/usercenter/findpaypasswordtype" class="forgetBtn"></mu-flat-button> -->
          <mu-flat-button label="忘记密码" @click="goPhone" class="forgetBtn"></mu-flat-button>
        </mu-col>
      </mu-row>   
    </div>
    <XR-toast @onClose="goBack" ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import md5 from 'js-md5'
export default {
  data () {
    return {
      editInfo:{
        payPassword : '',
        newPayPassword:'',
        isTestPhone:false,
        confrimNewPayPassword:''
      }
    }
  },
  mounted(){
    this.getMemberInfo()
  },
  methods: {
    submit: function(){
      var ths = this;  
      
      if(!ths.editInfo.payPassword){
          ths.$refs.XRtoast.failed('请输入旧密码', true)
          return
      }
      if(!ths.editInfo.newPayPassword){
          ths.$refs.XRtoast.failed('请输入新密码', true)
          return
      }
      if(ths.editInfo.newPayPassword != ths.editInfo.confrimNewPayPassword){
          ths.$refs.XRtoast.failed('二次输入的密码不一致', true)
          return
      }

      ths.$post(
        "/Shop/UserServer/ModifyPayPassword",
        JSON.stringify(this.editInfo)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.editInfo.payPassword =  ''
          ths.editInfo.newPayPassword =  ''
          ths.editInfo.confrimNewPayPassword = ''
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{
          ths.$refs.XRtoast.success(res.Msg, true)
        }
      });
    },
    getMemberInfo(){
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserInfo"
      ).then(function(res) {
        ths.loaded =false          
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.$refs.XRtoast.hide()
          ths.isTestPhone = res.Data.IsTestPhone
        }
      });      
    },
    goPhone(){
      if(!this.isTestPhone){
          this.$refs.XRtoast.failed('您未绑定手机', true)
          return
      }
      this.$router.push("/usercenter/paypasswordReset")
    },
    goBack(){
      this.$router.goBack()
    }
  }
}
</script>
<style>
.pagePaypasswordEdit{
  background: white;
}
.pagePaypasswordEdit .rowFiled{
  padding: 0 5%;
}
.pagePaypasswordEdit .forgetBtn {
  float: right;
}

.pagePaypasswordEdit .btn-div {
  padding: 40px 5% 30px;
}
.pagePaypasswordEdit .submit {
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/paypasswordEdit.vue